<template>
  <div>
    <div
        class="modal-dialog save"
        v-if="modalToggle"
    >
        <div class="modal-content">
            <div class="modal-header">
                <div>
                    <h4>保存</h4>
                </div>
            </div>
            <div class="modal-body">
                <ul>
                    <li>後日入力作業を再開することができます。</li>
                    <li>保存を行うとXMLファイルが生成されます。パソコン等に保存して下さい。</li>
                    <li>計算結果は保存されません。</li>
                </ul>
            </div>
            <div class="modal-footer">
                <app-button
                    value="キャンセル"
                    @button-click="cancel"
                    this-class="btn_cancel"
                />
                <app-button
                    value="保存"
                    @button-click="save"
                    this-class=""
                />
            </div>
        </div>
    </div>
  </div>
</template>


<script>
/**
 * XML出力用モーダル
 * 
 * [イベント処理]
 * 保存ボタン押下時 ... this.$emit('save')
 * キャンセルボタン押下時 ... this.$emit('modal-save-hide')
 * 
 * [利用例]
 * <modal-save
 *    v-if="modalSaveShow"
 *    @save="save"
 *    @modal-save-hide="hideSave"
 * />
 * 
 * [データ]
 * modalToggle ... 本コンポーネントの表示制御、trueで表示
 */
export default {
    name:"ModalSave",
    data(){
        return {
            /**
             * 本コンポーネントの表示制御、trueで表示
             */
            modalToggle: true,
        }
    },
    methods: {
        /**
         * 保存ボタンのクリックイベントを親コンポーネントに伝える
         */
        save(){
            this.$emit('save')
        },
        /**
         * キャンセルボタンのクリックイベントを親コンポーネントに伝える
         */
        cancel(){
            this.$emit('modal-save-hide')
        }
    },
}
</script>

<style lang="scss" scoped>
.save .modal-content{
    width: 500px;
}
div.modal-dialog{
    display: block;
    width: 100%;
    height: 100%;
    min-height: 80vh;
    padding: 0;
    margin: 0;
    background-color: rgba(0, 0, 0, 0.2);
    position: fixed;
    overflow-y:auto;
    -ms-overflow-style:none;
    top: 0;
    z-index: 9999;
}
_:-ms-lang(x)::-ms-backdrop, div.modal-dialog {
    overflow: hidden;
}
.modal-content{
    display: block;
    width: 75%;
    max-height: 90vh;
    margin:  65px auto;
    padding: 1em 4em;
    background-color: white;
    border-radius: 5px;
    box-shadow: 0 5px 15px 2px rgba(0, 0, 0, 0.5);
}
.modal-header{
    display: -ms-grid;
    display: grid;
    grid-template-columns: 10em 1fr;
    -ms-grid-columns: 10em 1fr;/* IE11 */
    align-items: center;
    h4{
        letter-spacing: 0.25em;
    }
}
.modal-lang{
    grid-column: 2;
    -ms-grid-column: 2;
    text-align: end;
    label{
        margin: 0 8px;
        &:after{
            display: none;
        }
    }
}
.modal-body{
    display: block;
    height: auto;
    max-height: 50vh;
    overflow-x: hidden;
    overflow-y: scroll;
}
.modal-body::-webkit-scrollbar {
  display: none;
}
.modal-footer{
    display: flex;
    justify-content: flex-end;
}
</style>


